export const config = {
    locations: [
        {
            name: "Moore Hall 100",
            lat: 34.07062369936824,
            long: -118.44262440271551,
            location_rank: 0,
            correct: false,
            text: "Moore Hall 100 is UCLA’s largest lecture hall in terms of the capacity, which is 442 people. This lecture hall is accessible from both outside and inside Moore Hall. The outdoor entrance is accessed from Kerckhoff Patio. Moore Hall 100 has three projectors that can show three different images.",
        },
        {
            name: "Haines Hall 39",
            lat: 34.072985124174316, 
            long: -118.44116808922068,
            location_rank: 1,
            correct: false,
            text: "Haines Hall 39 has a capacity of 419 and is the second largest lecture hall on UCLA’s campus. Haines Hall 39 is accessible from the A level of Haines Hall or from an outdoor entrance facing Royce Hall.",
        },
        {
            name: "Broad Art Center 2160E",
            lat: 34.07606271350316, 
            long: -118.44099690271537,
            location_rank: 2,
            correct: false,
            text: "Broad Art Center 2160E is UCLA’s third largest lecture hall, with a capacity of 406 people. Despite being located in the art building, it is used for many different large-sized classes. Broad Art Center 2160E is accessible from the staircase closest to the Franklin D. Murphy Sculpture Garden by the left front side of Broad Art Center.",
        },
        {
            name: "Dodd Hall 147",
            lat: 34.072729233494925, 
            long: -118.4393080738803, 
            location_rank: 3,
            correct: false,
            text: "Dodd Hall 147, with a capacity of 366, is UCLA’s fourth largest lecture hall. This lecture hall still has chalk boards instead of white boards. It can be accessed from inside Dodd Hall and is visible from the main entrance facing the sunken courtyards.",
        },
        {
            name: "La Kretz Hall 110",
            lat: 34.0677283808849, 
            long: -118.44260980086992, 
            location_rank: 4,
            correct: false,
            text: "La Kretz Hall 110 is known to some students as one of the steepest lecture halls on campus. It has a capacity of 352 and is used for classes and exams. There are doors to this lecture hall outside the building on its left and right sides. It is also accessible from the second floor of La Kretz Hall if you walk up the first flight of stairs on the left side of the building.",
        },
        {
            name: "Young Hall CS50",
            lat: 34.06874275402087,
            long: -118.44147921621028,
            location_rank: 5,
            correct: false,
            text: "Young Hall CS50 is a common lecture hall for STEM major classes and examinations. It has a capacity of 351 people. You can find this classroom if you go down to the Court of Sciences and walk right through the entrance to Young Hall located through the large columns on the left of the courtyard. CS50 is the lecture hall at the center of the Young Hall courtyard.",
        },
        {
            name: "Fowler Museum A103B",
            lat: 34.07316678045883,
            long: -118.4431084603857,
            location_rank: 6,
            correct: false,
            text: "Fowler Museum A103B, with a capacity of 320 people, is one of the only lecture halls located not inside a hall, but instead a museum. You can find this classroom if you enter the Fowler Museum from its lower entrance which you can find on your right side as you are coming down from Janss Steps.",
        },
        {
            name: "Franz Hall 1178",
            lat: 34.06981103931228,
            long: -118.44126847388037, 
            location_rank: 7,
            correct: false,
            text: "Franz Hall 1178 has modern accommodations and a capacity of 286 people, which make it a common lecture hall for large-sized classes. It can be accessed from the entrance of Franz Hall, which faces the walkway between Portola Plaza and the Inverted Fountain. It can also be accessed through the side entrance, which faces the Mathematical Sciences Building, or its back entrance, which faces the Geology Building.",
        },
        {
            name: "Rolfe Hall 1200",
            lat: 34.07392384423624,
            long: -118.44212267572591,
            location_rank: 8,
            correct: false,
            text: "Rolfe Hall 1200 is the ninth largest lecture hall at UCLA with a 292 person capacity. Despite its name, Rolfe Hall 1200 is not actually inside Rolfe Hall, but rather right outside of it. You can access this lecture hall through its doors that are adjacent to the Rolfe Hall entrance.",
        },
        {
            name: "Kaplan Hall A51",
            lat: 34.071269823561025, 
            long: -118.4411509027156, 
            location_rank: 9,
            correct: false,
            text: "The tenth largest lecture hall at UCLA is Kaplan Hall A51 with a capacity of 290 people. You can access this lecture hall through its two entrances on the side of Kaplan Hall that faces Powell Library.",
        }
    ]
};